import React from 'react';
import { GlobeIcon, LockIcon, FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OfferCountdown } from './OfferCountdown';
import { ScarcityBar } from './ScarcityBar';
type OfferCardProps = {
  ctaLabel: string;
  showValue?: boolean;
};
export function OfferCard({
  ctaLabel,
  showValue = true
}: OfferCardProps) {
  return <div className="mx-auto w-full max-w-xl overflow-hidden rounded-3xl bg-white text-ink shadow-[0_30px_60px_-20px_rgba(6,18,42,0.45)] ring-1 ring-black/5" data-id="element-52" data-mp="mkgf0t57lush">
      <div className="flex items-center justify-center gap-2 bg-pulse px-4 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-53" data-mp="1f82hfy2patdr">
        <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="15gzfku1y6adf" />
        Special introductory offer
      </div>

      <div className="flex flex-col items-center gap-5 px-5 py-7 text-center sm:px-8" data-id="element-55" data-mp="22w3lousujnnd">
        {showValue && <p className="text-base font-semibold text-muted" data-id="element-56" data-mp="1y53rhxb43jok">
            Total illustrative value:{' '}
            <span className="text-pulse line-through decoration-2" data-id="element-57" data-mp="8fjfp7pnjuqt">$237 USD</span>
          </p>}

        <div data-id="element-58" data-mp="ddunze0atx6x">
          <p className="text-sm font-bold uppercase tracking-wider text-navy-700" data-id="element-59" data-mp="ddkyrsn2vu2a">Today just</p>
          <p className="font-display text-7xl font-black leading-none text-navy-900 sm:text-8xl" data-id="element-60" data-mp="3vs3vzwxkkjy0">
            $27
            <span className="ml-1 align-top text-2xl font-extrabold text-muted sm:text-3xl" data-id="element-61" data-mp="3njgjhhep5va">USD</span>
          </p>
          <p className="mt-2 inline-block rounded-full bg-gold px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-navy-950" data-id="element-62" data-mp="3lwsitj1t7ksd">
            One-time payment · Save 88%
          </p>
        </div>

        <CTAButton label={ctaLabel} data-id="element-63" data-mp="3cwdt87htbjj2" />

        <p className="-mt-2 flex items-center gap-1.5 text-sm font-medium text-muted" data-id="element-64" data-mp="3guuq7y7irdmr">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-65" data-mp="1b24rxyjnav0o" />
          Instant digital access · No recurring fees
        </p>

        <OfferCountdown data-id="element-66" data-mp="1f2yg8t102bu3" />

        <ScarcityBar data-id="element-67" data-mp="1f3gic6acfk9x" />

        <div className="flex w-full items-start gap-3 rounded-2xl bg-mist p-4 text-left" data-id="element-68" data-mp="2o16ooey1fjgd">
          <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-69" data-mp="2nytxrcaaxyr6" />
          <p className="text-sm text-ink" data-id="element-70" data-mp="2j47rtomzoyeh">
            <strong className="font-bold" data-id="element-71" data-mp="2ezqd43vhlbak">Automatic currency conversion.</strong> Buying from outside the US? The
            $27 USD price is converted to your local currency automatically at checkout.
          </p>
        </div>
      </div>
    </div>;
}